// GOVGR-FIELD
export const GOVGR_FIELD = "govgr-field";
export const GOVGR_FIELD__ERROR = "govgr-field__error";

// GOVGR HEADING
export const GOVGR_HEADING_S = "govgr-heading-s";

// GOVGR-HINT
export const GOVGR_HINT = "govgr-hint";

// GOVGR-DATE-INPUT
export const GOVGR_DATE_INPUT = "govgr-date-input";
export const GOVGR_DATE_INPUT__ITEM = "govgr-date-input__item";

// GOVGR-INPUT
export const GOVGR_INPUT = "govgr-input";
export const GOVGR_INPUT__WIDTH_3 = "govgr-input--width-3";

// GOVGR-ERROR-MESSAGE
export const GOVGR_ERROR_MESSAGE = "govgr-error-message";
export const GOVGR_ERROR_INPUT = "govgr-error-input";

// GOVGR-VISUALLY-HIDDEN
export const GOVGR_VISUALLY_HIDDEN = "govgr-visually-hidden";

// GOVGR_LABEL
export const GOVGR_LABEL = "govgr-label";
